import { rest } from 'msw';
import { LMS_BACK_URL } from 'config/variables';

import { banksMock, questionFormMock } from '../questionBank.mock';

const getQuestionBanks = rest.get(
  `${LMS_BACK_URL}bank-questions/get-question-banks/:clientId/:userId`,
  (req, res, ctx) => {
    // access query string params
    const search = req.url.searchParams.get('search');
    return res(
      ctx.delay(2000),
      ctx.json({
        data: search ? [] : banksMock,
        status: 'success',
      }),
    );
  },
);

const deleteQuestionBank = rest.delete(
  `${LMS_BACK_URL}bank-questions/delete-question-bank/:clientId/:userId/:bankId`,
  (req, res, ctx) => {
    return res(
      ctx.delay(2000),
      ctx.json({
        data: null,
        status: 'success',
      }),
    );
  },
);

const getQuestionBank = rest.get(
  `${LMS_BACK_URL}bank-questions/get-question-bank/:clientId/:userId/:bankId`,
  (req, res, ctx) => {
    return res(
      ctx.delay(2000),
      ctx.json({
        data: questionFormMock,
        status: 'success',
      }),
    );
  },
);

const editQuestionBank = rest.put(
  `${LMS_BACK_URL}bank-questions/edit-question-bank/:clientId/:userId/:bankId`,
  (req, res, ctx) => {
    return res(
      ctx.delay(2000),
      ctx.json({
        data: null,
        status: 'success',
      }),
    );
  },
);

export const questionBankHandlers = [
  getQuestionBanks,
  deleteQuestionBank,
  getQuestionBank,
  editQuestionBank,
];
